export default __webpack_public_path__ + "static/media/Kannada_em_1.16e96f8b.mp3";